import { useMemo, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";

import TaxiServiceService from "../services/TaxiService2";
import { useTypedSelector } from "../redux/store";
import { sessionAction } from "../redux/reducers/session";

const useTaxiServiceDefault = () => {
	const dispatch = useDispatch();
	const settingsLanguage = useTypedSelector(
		(state) => state.session.language,
	);
	const defaultTaxiServiceId = useTypedSelector(
		(state) => state.session.defaultTaxiServiceId,
	);
	const user = useTypedSelector((state) => state.account.user);

	const defaultTaxiService = useMemo(
		() =>
			user?.defaultTaxiService
				? TaxiServiceService.fromResponse(user.defaultTaxiService)
				: null,
		[user?.defaultTaxiService],
	);

	useLayoutEffect(() => {
		if (
			defaultTaxiService &&
			defaultTaxiService.id !== defaultTaxiServiceId
		) {
			dispatch(
				sessionAction.setDefaultTaxiServiceId(
					defaultTaxiService.id || null,
				),
			);
		}
	}, [defaultTaxiService, defaultTaxiServiceId, dispatch]);

	const company = useMemo(
		() => defaultTaxiService?.company?.name[settingsLanguage] || null,
		[defaultTaxiService?.company?.name, settingsLanguage],
	);

	const taxiService = useMemo(
		() => defaultTaxiService?.settlement?.[settingsLanguage] || null,
		[defaultTaxiService?.settlement, settingsLanguage],
	);

	return { defaultTaxiService, company, taxiService };
};

export default useTaxiServiceDefault;
